import { useEffect, useRef } from 'react';

import { useLLMActionRegistryContext } from '../llm-action-registry/llm-action-registry-context';

export const useLLMViewContext = (actionId: string | null, getContext: () => Record<string, unknown>) => {
  const registry = useLLMActionRegistryContext();
  const getContextRef = useRef(getContext);
  getContextRef.current = getContext;

  useEffect(() => {
    if (!actionId) return;

    registry.setViewContext(actionId, () => getContextRef.current());
    return () => registry.clearViewContext(actionId);
  }, [registry, actionId]);
};
